/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '../../../services/toast';
export default {
  name: 'account-su-updates-create',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      content:'',
      is_visible:true
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              content:this.content,
              is_visible:this.is_visible
            }
            this.$store.dispatch('createSuAcUpdatesListFun', data)
              .then((res) => {
                  toast.success(res.data.msg);            
                  this.$router.push('/su/account/updates/list/');
              }).catch((err) => {
                toast.error(err.data.user_msg);  
              })
            return;
        }
      });
    }
  },
  watch:{
  }
}


